<template>
  <c-expansion-panel>
    <template v-slot:header="{ expand }">
      <div class="pa-4">
        <v-layout align-center class="pa-1 unselectable">
          <div class="headline font-weight-medium">
            Raw materials ({{ items.length }})
          </div>
          <v-tooltip 
          v-if="totalPercent !== 100"
          bottom open-delay="300">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" color="red">mdi-alert-octagram</v-icon>
            </template>
            <span>Percent needs to equal 100</span>
          </v-tooltip>
          <v-tooltip 
          v-if="totalWeight !== localNetWeight"
          bottom open-delay="300">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" color="red">mdi-alert-octagram</v-icon>
            </template>
            <span>Quantity column total not equal to net weight. Recalculate</span>
          </v-tooltip>
          <div class="c-hr" style="flex-grow: 1;"></div>
          <v-icon :class="{'rotate-180': expand}">mdi-chevron-down</v-icon>
        </v-layout>
      </div>
    </template>
    <template v-slot:body>
      <div>
        <div style="flex-grow: 1;">

          <v-layout align-center ma-4>
            <v-flex xs3 class="left-label">
              Net weight
            </v-flex>
            <v-flex xs9>
              <c-ms-ii
              sid="si-mass-g"
              :key="1"
              class="crx-box-input"
              :realValue.sync="localNetWeight">
              </c-ms-ii>
            </v-flex>
          </v-layout>
          <!-- RAW MATERIALS -->
          <div>

            <div class="pt-2 pb-2">
              <div style="position:relative;">
                <div>
                  <!-- top toolbar -->
                  <v-layout align-center pl-2 pr-2>
                    <v-menu offset-y>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          v-on="on"
                        >
                          <v-icon>mdi-check-box-multiple-outline</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-tile
                        @click="selectAll">
                          <v-list-tile-title>Select all</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile
                        @click="selectPage">
                          <v-list-tile-title>Select page</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile
                        @click="selectNone">
                          <v-list-tile-title>Select none</v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                    <transition
                    name="slide-y-reverse-transition"
                    mode="out-in">
                      <div v-if="selectedCount > 0"
                      key="1"
                      class="c-flex-r align-center subheading">
                        <v-btn
                        icon
                        class="ma-0"
                        @click="selected = {}">
                          <v-icon color="color1">close</v-icon>
                        </v-btn>
                        <div class="text-sans font-weight-medium">
                          <span>&nbsp;{{ selectedCount }}</span>
                          selected 
                        </div>
                        <span class="icon--text ml-2">|</span>
                        <v-btn 
                        icon
                        @click="onDelete">
                          <v-icon>delete_outline</v-icon>
                        </v-btn>
                        <!-- select menu -->
                        <v-menu offset-y>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              icon
                              v-on="on"
                            >
                              <v-icon>mdi-check-box-multiple-outline</v-icon>
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-tile
                            @click="selectAll">
                              <v-list-tile-title>Select all</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile
                            @click="selectPage">
                              <v-list-tile-title>Select page</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile
                            @click="selectNone">
                              <v-list-tile-title>Select none</v-list-tile-title>
                            </v-list-tile>
                          </v-list>
                        </v-menu>
                      </div>
                      <div v-else>
                        <v-btn 
                        text color="color1" class="ma-0"
                        @click="selectOutput">
                          Add item
                        </v-btn>
                      </div>
                    </transition>
                    <v-spacer></v-spacer>

                    
                    <v-btn
                    icon
                    class="ma-0"
                    color="blue"
                    :disabled="page <= 0"
                    @click="page--">
                      <v-icon>keyboard_arrow_left</v-icon>
                    </v-btn>

                    <v-btn
                    icon
                    color="blue"
                    class="ma-0"
                    :disabled="page >= paginationLength - 1"
                    @click="page++">
                      <v-icon>keyboard_arrow_right</v-icon>
                    </v-btn>
                  </v-layout>

                </div>

                <div style="overflow: auto;">
                  <table class="final-table lines-r">
                    <colgroup ref="colgroup1">
                      <col width="400px">
                      <col width="200px">
                      <col width="100px">
                    </colgroup>

                    <tr class="unselectable">
                      <th class="sticky" style="white-space: nowrap;">
                          Items ({{ items.length }})
                          <div class="handle" @mousedown="startColDrag(0, $event)"></div>
                      </th>
                      <th>
                        Quantity
                        (<c-ms-ii
                        sid="si-mass-g"
                        :realValue="totalWeight"
                        alwaysScale
                        labelMode
                        ></c-ms-ii>)
                        <v-tooltip 
                        v-if="totalWeight !== localNetWeight"
                        bottom open-delay="300">
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" color="red">mdi-alert-octagram</v-icon>
                          </template>
                          <span>Quantity column total not equal to net weight. Recalculate</span>
                        </v-tooltip>
                        <v-icon v-if="allRMSHaveWeightRatio">check</v-icon>
                        <div class="handle" @mousedown="startColDrag(1, $event)"></div>
                        </th>
                      <th>
                        <span v-if="isNaN(totalPercent)">
                          Percent (Error)
                        </span>
                        <span v-else>
                          Percent ({{ totalPercent }}%)
                        </span>
                        <v-tooltip 
                        v-if="totalPercent !== 100"
                        bottom open-delay="300">
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" color="red">mdi-alert-octagram</v-icon>
                          </template>
                          <span>Percent needs to equal 100</span>
                        </v-tooltip>
                        <div class="handle" @mousedown="startColDrag(2, $event)"></div>
                      </th>
                    </tr>
                  </table>

                  <table class="final-table">
                    <colgroup ref="colgroup2">
                      <col width="400px">
                      <col width="200px">
                      <col width="100px">
                    </colgroup>
                    <tr>
                      <td class="sticky">
                        <v-text-field
                        v-model="searchText"
                        placeholder="Search..."
                        hide-details
                        class="crx-box-input"
                        clearable
                        color="color1"
                        solo></v-text-field>
                      </td>
                      <td>
                        <v-layout align-center>
                          <v-tooltip 
                          top open-delay="300">
                            <template v-slot:activator="{ on }">
                              <v-btn
                              v-on="on"
                              icon
                              :disabled="!allRMSHaveWeightRatio"
                              class="ma-0"
                              @click="autoCalculate">
                                <v-icon>
                                  mdi-calculator
                                </v-icon>
                              </v-btn>
                            </template>
                            <template v-if="!allRMSHaveWeightRatio">
                              You have an item without a weight conversion and therefore cannot use this function
                            </template>
                            <template v-else>
                              Recalculate this column based on net weight
                            </template>
                          </v-tooltip>
                          <v-spacer></v-spacer>
                          <c-preffered-metric-selector :sid.sync="prefferedSid">

                          </c-preffered-metric-selector>
                        </v-layout>
                      </td>
                      <td>
                        <v-btn
                        icon
                        :disabled="!allRMSHaveWeightRatio"
                        class="ma-0"
                        @click="autoCalculatePercent">
                          <v-icon>
                            mdi-calculator
                          </v-icon>
                        </v-btn>
                      </td>
                    </tr>
                    <draggable 
                    :list="paginatedArray"
                    :element="'tbody'"
                    :options="{animation: 150, handle: '.drag-handle'}"
                    @change="dragChange">
                      <raw-material-row 
                      v-for="item in paginatedArray"
                      :vmode="0"
                      :key="item.tempID" 
                      :item="item"
                      :searchText="searchText"
                      :selected="selected"
                      :prefferedSid="prefferedSid"
                      @checkRow="checkRow(item)"
                      @click.native="clickRow(item)">
                      </raw-material-row>
                    </draggable>
                  </table>
                </div>

              </div>

              <!-- PAGINATION -->
              <c-pagination-client
              :page="page"
              :paginationLength="paginationLength"
              :paginatedArray="paginatedArray"
              :rowsPerPage.sync="rowsPerPage"
              @updatePageNumber="updatePageNumber"
              @goToFirstPage="goToFirstPage"
              @goToPreviousPage="goToPreviousPage"
              @goToNextPage="goToNextPage"
              @goToLastPage="goToLastPage">
              </c-pagination-client>
              <!-- PAGINATION -->

            </div>

            <!-- DIALOGS -->
            <c-select-inv-def-dialog ref="selectItemDialog" :exceptions="exceptionIdArray">
            </c-select-inv-def-dialog>

            <!-- DIALOG -->
            <v-dialog
            v-model="dialog"
            persistent 
            scrollable
            transition="c-anim-slide-left-fade"
            :fullscreen="$vuetify.breakpoint.xs" 
            content-class="c-dialog-border-13"
            max-width="400px">
              <v-card>
                <v-layout class="mobile-toolbar c-flex-00a">
                  <v-btn
                  icon
                  @click="dialog = false">
                    <v-icon>arrow_back</v-icon>
                  </v-btn>
                  <div class="c-flex-r1 align-center text-sans font-weight-bold">
                    Edit row
                  </div>
                  <v-btn
                  icon
                  @click="updateRow">
                    <v-icon>check</v-icon>
                  </v-btn>
                </v-layout>
                <div style="overflow: auto;" class="pa-3">
                  <raw-material-row 
                  :vmode="2"
                  :key="selectedItem.tempID" 
                  :item="clonedRow">
                  </raw-material-row>
                </div>
              </v-card>
            </v-dialog>
            <!-- END DIALOG -->

          </div>
          <!-- END RAW MATERIALS -->
        </div>
      </div>
    </template>
  </c-expansion-panel>
</template>

<script>
import RawMaterialRow from './RawMaterialRow'
import Draggable from 'vuedraggable'
import ListController from '@/mixins/ListController'
import {BigNumber} from 'bignumber.js'

export default {
  props: ['id', 'itemsSource', 'netWeight'],
  mixins: [ListController],
  components: {
    RawMaterialRow,
    Draggable
  },
  data () {
    return {
      dialog: false,
      sortLive: false,
      prefferedSid: null,
      selectedItem: {},
      clonedRow: {},
      localNetWeight: this.netWeight,
      colDragEvent: {
        dragging: false,
        mouseXStart: 0,
        startWidth: 0,
        index: 0
      }
    }
  },
  watch: {
    itemsSource (nv) {
      this.items = nv
    },
    items (nv) {
      this.$emit('update:itemsSource', nv)
    },
    netWeight (nv) {
      this.localNetWeight = nv
    },
    localNetWeight (nv) {
      this.$emit('update:netWeight', nv)
    }
  },
  computed: {
    exceptionIdArray () {
      return this.items.map(item => item.inventory_item_id)
    },
    totalPercent () {
      var ret = this.items.reduce((a, i) => {
        return a.plus(new BigNumber(i.percent))
      }, new BigNumber(0))
      return ret.toNumber()
    },
    totalWeight () {
      var errorItems = []
      var tq = this.items.reduce((a, b) => {
      
        var definition = b.definition
        if (!definition) {
          return a
        }

        var ratio = this.$crx.metrics.getWeightRatio(definition)
        if (!ratio) {
          errorItems.push(b.name)
          return a
        }
        return a.plus(ratio.times(b.quantity))
      }, new BigNumber(0))
      return tq.toNumber()
    },
    allRMSHaveWeightRatio () {
      for (var item of this.items) {
        if (!this.$crx.metrics.getWeightRatio(item.definition)) {
          return false
        }
      }
      return true
    }
  },
  methods: {
    mouseUp (index) {
      this.colDragEvent.dragging = false
      this.colDragEvent.index = null
    },
    onMouseMove (e) {
      if (this.colDragEvent.dragging) {
        var distance = this.colDragEvent.startWidth + (e.pageX - this.colDragEvent.startX)
        if (distance < 20) { // minimum cell width (should be positive)
          distance = 20
        }
        this.$refs.colgroup1.children[this.colDragEvent.index].style.width = distance + 'px'
        this.$refs.colgroup2.children[this.colDragEvent.index].style.width = distance + 'px'
      }
    },
    startColDrag (index, event) {
      this.colDragEvent.startWidth = event.target.parentElement.offsetWidth
      this.colDragEvent.startX = event.clientX
      this.colDragEvent.dragging = true
      this.colDragEvent.index = index
    },
    updateRow () {
      Object.assign(this.selectedItem, this.clonedRow)
      this.dialog = false
    },
    clickRow (item) {
      if (this.selectedCount > 0) {
        this.checkRow(item)
      } else {
        /* this.selectedItem = item
        this.clonedRow = JSON.parse(JSON.stringify(item))
        this.dialog = true */
      }
    },
    autoCalculate () {
      console.log('calculateing')
      for (var item of this.items) {
        var newValue = new BigNumber(item.percent).dividedBy(100).times(this.netWeight)
        if (isNaN(newValue)) {
          newValue = 0
        }
        item.quantity = newValue
      }
    },
    autoCalculatePercent () {
      console.log('calculateing')
      for (var item of this.items) {
        var newValue = new BigNumber(item.quantity).dividedBy(this.totalWeight).times(100)
        if (isNaN(newValue)) {
          newValue = 0
        }
        item.percent = newValue
      }
    },
    selectOutput () {
      this.$refs.selectItemDialog.open()
        .then((selectedItem) => {
          this.items.push({
            definition: Object.assign({}, selectedItem),
            name: selectedItem.name,
            inventory_item_id: selectedItem.id,
            quantity: 0,
            percent: 0,
            type: 0
          })
        })
        .catch(() => {
          // console.log('rejected')
        })
    },
    sort (items) {
      return items.sort((a, b) => a.ordering - b.ordering)
    },
    search (items) {
      if ((this.searchText || '').length > 0) {
        var keywords = (this.searchText || '').toLowerCase().split(' ')
        items = items.filter(item => {
          return keywords.every(keyword => {
            return (item.name.toLowerCase()).indexOf(keyword) > -1
          })
        })
      }
      return items
    },
    onDelete () {
      var selectedRows = this.getSelectedRows()
      var idArray = selectedRows.reduce((a, i) => {
        a.push(i.tempID)
        return a
      }, [])
      var title = 'Delete ' + idArray.length + ' item' + (idArray.length === 1 ? '' : 's') + '?'
      this.$root.$confirm(title, 'Are you sure?', { color: 'purple' }).then((confirm) => {
        if (confirm) {
          for (var i = this.items.length - 1; i >= 0; --i) {
            if (idArray.includes(this.items[i].tempID)) {
              this.items.splice(i, 1)
            }
          }
          this.onSuccessfullDelete()
        }
      })
    }
  },
  mounted () {
    window.addEventListener('mousemove', this.onMouseMove)
    window.addEventListener('mouseup', this.mouseUp)
  }
}
</script>

<style scoped lang="scss">
.flex-cell {
  padding: 5px;
  border-right: 1px solid var(--v-hline-base);
  display:flex;
  align-items: center;
  text-overflow: ellipsis;
  overflow: hidden;
}
.flextable-hr {
  border-bottom: 2px solid var(--v-hline-base);
  font-size: 14px;
  text-transform: uppercase;
  box-shadow: 0px 0px 1px 0px RGBA(57, 97, 120, 0.3);
}
</style>
